// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603301203/js/" + chunkId + "." + {"44":"cebe1008","225":"6b1c774b","481":"e3ca0f28","486":"488f8953","770":"60da7a03"}[chunkId] + ".0.11370161960510083.chunk.js";
};